import PropTypes from 'prop-types';
import cx from 'classnames';
import { SaleIcon } from 'cat-ecommerce-alloy';
import styles from '../../styles.module.scss';

const ProductSpecials = ({ specials = {} }) => {
  const { description, name } = specials;
  return (
    <section className="mb-4">
      <p className="d-flex align-items-end mb-1">
        <SaleIcon className={cx('me-1', styles['product-specials_icon'])} />
        <span className="m-0 exclude-global text-md text-univers color-extra-dark-gray">
          {name ?? ''}
        </span>
      </p>
      {description && (
        <p
          className="ms-4 ps-2 mb-0 exclude-global text-xs"
          data-testid="product-specials_description"
        >
          {description}
        </p>
      )}
    </section>
  );
};

export default ProductSpecials;

ProductSpecials.propTypes = {
  specials: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string
  })
};
